// Función para detectar el país basado en el timezone del navegador
export function getCountryFromTimezone() {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Mapeo de timezones principales a códigos de país
    const timezoneToCountry = {
      // España
      'Europe/Madrid': 'ES',
      'Europe/Canary': 'ES',
      'Africa/Ceuta': 'ES',

      // Francia
      'Europe/Paris': 'FR',
      'Europe/Monaco': 'FR',

      // Italia
      'Europe/Rome': 'IT',
      'Europe/Vatican': 'IT',
      'Europe/San_Marino': 'IT',

      // Alemania
      'Europe/Berlin': 'DE',
      'Europe/Busingen': 'DE',

      // Portugal
      'Europe/Lisbon': 'PT',
      'Atlantic/Madeira': 'PT',
      'Atlantic/Azores': 'PT',

      // Reino Unido
      'Europe/London': 'GB',
      'Europe/Jersey': 'GB',
      'Europe/Guernsey': 'GB',
      'Europe/Isle_of_Man': 'GB',

      // Estados Unidos (principales)
      'America/New_York': 'US',
      'America/Chicago': 'US',
      'America/Denver': 'US',
      'America/Los_Angeles': 'US',
      'America/Phoenix': 'US',
      'America/Anchorage': 'US',
      'Pacific/Honolulu': 'US',

      // Argentina
      'America/Argentina/Buenos_Aires': 'AR',
      'America/Argentina/Cordoba': 'AR',
      'America/Argentina/Mendoza': 'AR',
      'America/Argentina/Tucuman': 'AR',

      // México
      'America/Mexico_City': 'MX',
      'America/Cancun': 'MX',
      'America/Tijuana': 'MX',
      'America/Chihuahua': 'MX',

      // Colombia
      'America/Bogota': 'CO',

      // Perú
      'America/Lima': 'PE',

      // Chile
      'America/Santiago': 'CL',
      'Pacific/Easter': 'CL',

      // Brasil
      'America/Sao_Paulo': 'BR',
      'America/Rio_Branco': 'BR',
      'America/Manaus': 'BR',
      'America/Recife': 'BR',
      'America/Fortaleza': 'BR',
      'America/Belem': 'BR',
    };

    // Buscar coincidencia exacta
    if (timezoneToCountry[timezone]) {
      return timezoneToCountry[timezone];
    }

    // Si no hay coincidencia exacta, intentar detectar por región
    if (timezone.startsWith('Europe/')) {
      // Mapeo de países europeos por timezone
      const europeanCountries = {
        'Amsterdam': 'NL',
        'Athens': 'GR',
        'Belgrade': 'RS',
        'Brussels': 'BE',
        'Bucharest': 'RO',
        'Budapest': 'HU',
        'Copenhagen': 'DK',
        'Dublin': 'IE',
        'Helsinki': 'FI',
        'Kiev': 'UA',
        'Lisbon': 'PT',
        'Ljubljana': 'SI',
        'Luxembourg': 'LU',
        'Madrid': 'ES',
        'Malta': 'MT',
        'Oslo': 'NO',
        'Paris': 'FR',
        'Prague': 'CZ',
        'Riga': 'LV',
        'Rome': 'IT',
        'Sofia': 'BG',
        'Stockholm': 'SE',
        'Tallinn': 'EE',
        'Vienna': 'AT',
        'Vilnius': 'LT',
        'Warsaw': 'PL',
        'Zurich': 'CH',
      };

      const city = timezone.split('/')[1];
      if (europeanCountries[city]) {
        return europeanCountries[city];
      }
    }

    // Si no se puede detectar, devolver España como país por defecto
    return 'ES';

  } catch (error) {
    console.warn('Error detecting country from timezone:', error);
    return 'ES'; // Fallback a España
  }
}

// Función simplificada que ya no usa geolocalización
export function getCountryFromGeolocation() {
  // Ahora solo usa timezone, sin solicitar permisos de geolocalización
  return getCountryFromTimezone();
}
